import { apiSlice } from '../../apiSlice'

export const paymentApiMethodApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllPaymentMethod: builder.query({
      query: () => '/payment-methods',
      keepUnusedDataFor: 600,
    }),
  }),
})

export const { useGetAllPaymentMethodQuery } = paymentApiMethodApi
